import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { DeleteQueueRequestComment } from 'domain/usecases';
import { RemoteDeleteQueueRequestComment } from 'data/usecases';

export const makeRemoteDeleteQueueRequestComment = (commentId: string): DeleteQueueRequestComment => {
  return new RemoteDeleteQueueRequestComment(
    makeApiUrl(`/queue/requests/comments/${commentId}`),
    makeAuthorizeHttpClientDecorator()
  );
};
